import { GraduationCap, Wrench, Boxes } from "lucide-react";
import { TRACKS } from "@/data/content";
import { Reveal } from "./Reveal";

const ICONS = { cap: GraduationCap, wrench: Wrench, boxes: Boxes };
const TONES = {
  blue: { card: "from-white to-blue-50/70 border-blue-100", icon: "text-blue-600", title: "text-blue-700" },
  teal: { card: "from-teal-50/80 to-white border-teal-100", icon: "text-teal-700", title: "text-[#0B1B33]" },
  violet: { card: "from-sky-50/80 to-white border-sky-100", icon: "text-sky-600", title: "text-[#0B1B33]" },
};

export const Tracks = () => (
  <section data-testid="tracks-section" className="grid gap-4 md:grid-cols-3">
    {TRACKS.map((t, i) => {
      const Icon = ICONS[t.icon];
      const tone = TONES[t.tone];
      return (
        <Reveal key={t.key} delay={i * 0.1}>
          <div data-testid={`track-${t.key}`} className={`card-lift group flex h-full items-center gap-5 rounded-2xl border bg-gradient-to-br p-5 ${tone.card}`}>
            <Icon className={`h-16 w-16 shrink-0 transition-transform duration-500 group-hover:scale-110 ${tone.icon}`} strokeWidth={1.4} />
            <div>
              <h3 className={`font-display text-[17px] font-bold tracking-wide ${tone.title}`}>{t.title}</h3>
              <p className="mt-1 text-[14px] leading-snug text-slate-700">{t.text}</p>
            </div>
          </div>
        </Reveal>
      );
    })}
  </section>
);
